(function(window, document){
  'use strict';
  var PS = window.PS || (window.PS = {});
  var Search = PS.Search;

  function json(value){ return JSON.stringify(value); }
  function unavailable(){
    return json({ status: 'unavailable', results: [], actions: [], message: 'PaintScratch search is unavailable right now. Try again later.' });
  }
  function invalid(){
    return json({ status: 'invalid', results: [], actions: [], message: 'Enter a search term up to 100 characters and a page from 1 to 10.' });
  }
  function validInput(input){
    var key;
    if (!input || typeof input !== 'object' || Object.prototype.toString.call(input) === '[object Array]' ||
        typeof input.query !== 'string') return false;
    for (key in input) if (Object.prototype.hasOwnProperty.call(input, key) && key !== 'query' && key !== 'page') return false;
    if (!input.query.replace(/^\s+|\s+$/g, '') || input.query.length > 100) return false;
    if (input.page != null && (typeof input.page !== 'number' || input.page % 1 !== 0 || input.page < 1 || input.page > 10)) return false;
    return true;
  }
  function safeSensitiveResult(query, reason){
    var data;
    try { data = Search.sensitiveData(query, reason); } catch (_e) { data = null; }
    if (!data || typeof data !== 'object') data = { status: 'action_required', results: [], actions: [] };
    data.query = '';
    data.query_redacted = true;
    (data.actions || []).forEach(function(action){
      if (action.kind === 'vehicle_selector') action.url = Search.withVehicle('/?ps_search_vehicle=1#ps-color-search');
      else if (action.id === 'label_photo') action.url = Search.withVehicle(action.url);
    });
    return json(data);
  }
  function execute(input){
    var query;
    var reason;
    var page;
    var url;
    var fetcher = window.fetch;
    if (!validInput(input)) return window.Promise.resolve(invalid());
    query = input.query.replace(/^\s+|\s+$/g, '');
    if (!Search || typeof Search.classifySensitive !== 'function' || typeof Search.sensitiveData !== 'function') return window.Promise.resolve(unavailable());
    try { reason = Search.classifySensitive(query); } catch (_e) { return window.Promise.resolve(unavailable()); }
    if (reason) return window.Promise.resolve(safeSensitiveResult(query, reason));
    if (typeof fetcher !== 'function') return window.Promise.resolve(unavailable());
    page = input.page == null ? 1 : input.page;
    url = '/search/results?q=' + encodeURIComponent(query) + '&page=' + page + '&per_page=10';
    try {
      return window.Promise.resolve(fetcher.call(window, url, { method: 'GET', credentials: 'same-origin', headers: { Accept: 'application/json' } })).then(function(response){
        if (!response || !response.ok || typeof response.json !== 'function') return unavailable();
        return window.Promise.resolve(response.json()).then(function(data){
          if (!data || typeof data !== 'object') return unavailable();
          return json(data);
        }, function(){ return unavailable(); });
      }, function(){ return unavailable(); });
    } catch (_e2) { return window.Promise.resolve(unavailable()); }
  }
  function register(){
    var modelContext;
    var registration;
    var tool = {
      name: 'paintscratch_search',
      description: 'Search PaintScratch vehicle, paint color, and paint code inventory, paint products, repair guides, VIN recovery, and support. Use this for the PaintScratch hybrid catalog because the generic Shopify catalog omits color inventory. Results are candidates, not confirmed matches. Visit the canonical color route and confirm the paint and vehicle before using the existing configured cart UI.',
      inputSchema: {
        type: 'object',
        properties: {
          query: { type: 'string', minLength: 1, maxLength: 100 },
          page: { type: 'integer', minimum: 1, maximum: 10 }
        },
        required: ['query'],
        additionalProperties: false
      },
      annotations: { readOnlyHint: true, untrustedContentHint: true, consequentialHint: false },
      execute: execute
    };
    try {
      modelContext = document && document.modelContext;
      if (!modelContext || typeof modelContext.registerTool !== 'function') return;
      registration = modelContext.registerTool(tool);
      if (registration && typeof registration.then === 'function') registration.then(function(){}, function(){});
    } catch (_e) {}
  }
  register();
})(window, document);
